import { render, staticRenderFns } from "./DashBoardv1.vue?vue&type=template&id=727ac691&"
import script from "./DashBoardv1.vue?vue&type=script&lang=js&"
export * from "./DashBoardv1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports